"use strict";
/**
 * Created by Ning Jiang on 5/29/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orientation = void 0;
var Orientation;
(function (Orientation) {
    Orientation["NONE"] = "notInitialized";
    Orientation["LANDSCAPE"] = "landscape";
    Orientation["PORTRAIT"] = "portrait";
})(Orientation = exports.Orientation || (exports.Orientation = {}));
//# sourceMappingURL=Orientation.js.map